import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { RouterHelperService } from '@core/services/router-helper/router-helper.service';

import {
  ORDERS_PAGE_BLOCK_DATA_SOURCE,
  ORDERS_PAGE_BLOCK_LOADING_VM,
  OrdersPageBlockDataSource,
  OrdersPageBlockViewModel,
} from './orders-page-block-view-model';
import { provideOrdersPageBlockDataSource } from './orders-page-block-data-source.providers';

@Component({
  selector: 'app-orders-page-block',
  templateUrl: './orders-page-block.component.html',
  standalone: false,
  providers: [...provideOrdersPageBlockDataSource()],
})
export class OrdersPageBlockComponent {
  protected readonly ordersPageVm$: Observable<OrdersPageBlockViewModel>;
  protected readonly loadingVm = ORDERS_PAGE_BLOCK_LOADING_VM;

  constructor(
    @Inject(ORDERS_PAGE_BLOCK_DATA_SOURCE)
    blockDataSource: OrdersPageBlockDataSource,
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
  ) {
    this.ordersPageVm$ = blockDataSource.vm$;
  }

  goToOrderDetails(id: string): void {
    this.router.navigate([this.routerHelper.translateRoute(`/orders/${id}/details`)]);
  }
}
